import { html } from 'lit';

export const linkTemplate = (
  node: HTMLAnchorElement,
) => html`<one-link href="${node.href}" target="_blank">${node.innerHTML}</one-link>`;

export default linkTemplate;
